// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_2JU4b","productItemBtn":"_1VjMp","productItem":"_3lRPi"};